/* RESPONSIBLE TEAM: team-automation-foundations */
import AutomationFinAIAgentProcedureSimulationsRoute from 'embercom/routes/apps/app/automation/fin-ai-agent/procedures/procedure/preview/simulations';

export default AutomationFinAIAgentProcedureSimulationsRoute;
